import moment from 'moment';
import { DATE_FORMAT_API, TIME_FORMAT_SHORT } from '@/constants/dateTimeFormats';

export function initialState() {
    return {
        isEditSession: false,
        clubUsers: [],
        clubSquads: [],
        exercises: [],

        details: {
            name: '',
            sessionType: '',
            all_day_event: false,
            startDate: moment()
                .set({ hour: 7, minute: 0 })
                .format(`${DATE_FORMAT_API} ${TIME_FORMAT_SHORT}`),
            endDate: moment()
                .set({ hour: 8, minute: 30 })
                .format(`${DATE_FORMAT_API} ${TIME_FORMAT_SHORT} `),
            totalDistance: '',
            totalTime: '',
            location: {},
            description: '',
            focuses: [],
            intensities: [],
            tags: [],
            repeat: {
                checked: null,
                editing: false,
                repeat_frequency_type: null,
                repeat_every: 1,
                repeat_on_the_specific_step: null,
                repeat_on_the_specific_every: null,
                repeat_end_date: null,
                repeat_numbers: null
            }
        },

        attendance: {
            creatorId: null,
            athletes: {},
            coaches: {},
            coach_permissions: {},
            athlete_permissions: {}
        },

        work: {
            seatRacing: false,
            createPieces: false,
            repetitions: null,
            pieceTypes: {
                single: true,
                multiple: false,
                variable: false
            },
            pieces: [
                {
                    distance: null,
                    time: null,
                    split_length: null,
                    variable_split_lengths: [],
                    rest: null
                }
            ],
            scStructures: []
        }
    };
}
